import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import LoginForm from "pages/login/LoginForm";
import NotFound from "pages/404/NotFound"; 
import ErrorBoundary from "./ErrorBoundary"; // Importa el Error Boundary 
import store from "store/Store";
import "./App.css";
import Home from "pages/main/Home";    
import Terms from "pages/main/Terms";
import Privacity from "pages/main/Privvacity";
import HomeStore from "pages/stores/HomeStore";
import HomeStoreEditData from "pages/stores/HomeStoreEditData";
const App =() => {  
  return(
    
    <Provider store={store}>
      <div className="App">
        <ErrorBoundary>  
          <Suspense fallback={null}>
            <section className="App-content">            
              <BrowserRouter>
                <Routes> 
                  <Route path="" element={<LoginForm key="login" />} />
                  <Route path="/*" element={<NotFound key="notfound" />} />
                  <Route path="/home" element={<Home key="home" />} />
                  <Route path="/terms" element={<Terms key="terms" />} />
                  <Route path="/privacity" element={<Privacity key="privacity" />} />
                  <Route path="/store" element={<HomeStore key="store" />} />
                  <Route path="/storedetail/:id" element={<HomeStoreEditData key="storedetail" />} />
                </Routes>
              </BrowserRouter>
            </section>
          </Suspense>
        </ErrorBoundary>
      </div>
    </Provider>
  );
};

export default App;